import React from 'react';

export function SignOut() {
    var aimsBaseUrl = process.env.REACT_APP_AIMS3D_URL as string;
    localStorage.removeItem('aims3d.authorizationData');
    window.location.href = aimsBaseUrl + "#/signOut";
    return <div></div>;
}
